import React, { useState, useEffect } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Chip,
} from '@mui/material';
import { Add } from '@mui/icons-material';
import { getAllFabrics, addMaterialMovement } from '../api';

export default function MaterialsList({ user }) {
  const [fabrics, setFabrics] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFormData] = useState({
    fabric_id: '',
    quantity: '',
    movement_type: 'income',
    reason: '',
  });

  useEffect(() => {
    loadFabrics();
  }, []);

  const loadFabrics = async () => {
    try {
      const response = await getAllFabrics();
      setFabrics(response.data);
    } catch (error) {
      console.error('Error loading fabrics:', error);
    }
  };

  const handleAddMovement = async () => {
    // Валидация
    if (!formData.fabric_id) {
      alert('Выберите ткань');
      return;
    }
    const qty = parseFloat(formData.quantity);
    if (!formData.quantity || isNaN(qty) || qty <= 0) {
      alert('Укажите количество больше нуля');
      return;
    }
    if (!formData.movement_type) {
      alert('Выберите тип операции');
      return;
    }
    try {
      await addMaterialMovement({
        ...formData,
        quantity: qty,
      });
      setOpenDialog(false);
      loadFabrics();
      setFormData({
        fabric_id: '',
        quantity: '',
        movement_type: 'income',
        reason: '',
      });
    } catch (error) {
      console.error('Error adding movement:', error);
      alert('Ошибка: ' + (error?.response?.data?.detail || error.message || 'не удалось сохранить'));
    }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'stretch', sm: 'center' }, gap: 2, mb: 4 }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700, color: '#0f172a', letterSpacing: '-0.02em' }}>
            Материалы
          </Typography>
          <Typography variant="body1" sx={{ color: '#64748b', mt: 0.5 }}>
            Управление остатками тканей и материалов
          </Typography>
        </Box>
        {user.role === 'admin' && (
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => setOpenDialog(true)}
            sx={{
              borderRadius: 2.5,
              px: 3,
              py: 1.25,
              fontWeight: 600,
              textTransform: 'none',
              background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
              boxShadow: '0 4px 14px rgba(30, 64, 175, 0.25)',
              '&:hover': {
                background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)',
                boxShadow: '0 6px 20px rgba(30, 64, 175, 0.35)',
              },
            }}
          >
            Добавить приход/расход
          </Button>
        )}
      </Box>

      <TableContainer 
        component={Paper} 
        sx={{ 
          borderRadius: 3, 
          border: '1px solid rgba(0, 0, 0, 0.06)',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.04)',
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ 
                bgcolor: '#f8fafc', 
                fontWeight: 600, 
                fontSize: '0.8rem',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: '#64748b',
                borderBottom: '2px solid #e2e8f0',
              }}>Название</TableCell>
              <TableCell sx={{ 
                bgcolor: '#f8fafc', 
                fontWeight: 600, 
                fontSize: '0.8rem',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: '#64748b',
                borderBottom: '2px solid #e2e8f0',
              }}>Остаток</TableCell>
              <TableCell sx={{ 
                bgcolor: '#f8fafc', 
                fontWeight: 600, 
                fontSize: '0.8rem',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: '#64748b',
                borderBottom: '2px solid #e2e8f0',
              }}>Единица измерения</TableCell>
              <TableCell sx={{ 
                bgcolor: '#f8fafc', 
                fontWeight: 600, 
                fontSize: '0.8rem',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: '#64748b',
                borderBottom: '2px solid #e2e8f0',
              }}>Статус</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fabrics.map((fabric) => (
              <TableRow 
                key={fabric.id}
                sx={{
                  transition: 'background-color 0.15s ease',
                  '&:hover': { bgcolor: 'rgba(30, 64, 175, 0.04)' },
                }}
              >
                <TableCell sx={{ fontWeight: 500, color: '#0f172a' }}>{fabric.name}</TableCell>
                <TableCell
                  sx={{
                    color: fabric.quantity < 10 ? '#374151' : '#0f172a',
                    fontWeight: fabric.quantity < 10 ? 700 : 500,
                  }}
                >
                  {fabric.quantity}
                </TableCell>
                <TableCell sx={{ color: '#64748b' }}>{fabric.unit}</TableCell>
                <TableCell>
                  {fabric.quantity < 10 ? (
                    <Chip 
                      label="Мало" 
                      size="small"
                      sx={{ 
                        bgcolor: '#f3f4f6', 
                        color: '#374151', 
                        fontWeight: 600,
                        fontSize: '0.75rem',
                      }}
                    />
                  ) : (
                    <Chip 
                      label="В наличии" 
                      size="small"
                      sx={{ 
                        bgcolor: '#f0f9f4', 
                        color: '#059669', 
                        fontWeight: 600,
                        fontSize: '0.75rem',
                      }}
                    />
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog 
        open={openDialog} 
        onClose={() => setOpenDialog(false)} 
        maxWidth="sm" 
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3 }
        }}
      >
        <DialogTitle sx={{ fontWeight: 600, color: '#0f172a' }}>
          Добавить движение материала
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="normal"
            select
            label="Ткань"
            value={formData.fabric_id}
            onChange={(e) => setFormData({ ...formData, fabric_id: e.target.value })}
          >
            {fabrics.map((fabric) => (
              <MenuItem key={fabric.id} value={fabric.id}>
                {fabric.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            fullWidth
            margin="normal"
            select
            label="Тип операции"
            value={formData.movement_type}
            onChange={(e) => setFormData({ ...formData, movement_type: e.target.value })}
          >
            <MenuItem value="income">Приход</MenuItem>
            <MenuItem value="expense">Расход</MenuItem>
          </TextField>
          <TextField
            fullWidth
            margin="normal"
            type="number"
            label="Количество"
            value={formData.quantity}
            onChange={(e) => setFormData({ ...formData, quantity: e.target.value })}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Причина"
            value={formData.reason}
            onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button 
            onClick={() => setOpenDialog(false)}
            sx={{ borderRadius: 2, textTransform: 'none' }}
          >
            Отмена
          </Button>
          <Button 
            onClick={handleAddMovement} 
            variant="contained"
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
            }}
          >
            Добавить
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
